import { deleteOrNop, setSafe } from "../../../util/storeHelper";
import * as actions from "../actions/transactions";
export const transactionsReducer = {
    reducers: {
        [actions.setTransferDownloads]: (state, payload) => {
            const { destination } = payload;
            return destination === undefined || destination === ""
                ? deleteOrNop(state, ["transfer", "downloads"])
                : setSafe(state, ["transfer", "downloads"], destination);
        },
    },
    defaults: {},
};
